/* @ngInject */
export class CritrereNombreDecimalController {
    constructor() {}
    $onInit() {}
    $onDestroy() {}
}
